import React, { useEffect, useState } from "react";
import {
  handleUserWebsites,
  handleUsers,
  handleUsersWithNoWebsites,
} from "../../axios";
import { useSelector } from "react-redux";
import {
  AppWindowIcon,
  ArrowUp01Icon,
  DollarSignIcon,
  LogInIcon,
  MousePointerSquareIcon,
  UsersIcon,
} from "lucide-react";
import { useNavigate } from "react-router-dom";

const UserReports = ({ users, subscriptions }) => {
  const { token } = useSelector((state) => state.auth);

  const [usersWithNoWebsite, setUsersWithNoWebsite] = useState({});
  const [userWebsites, setUserWebsites] = useState({});
  const navigate = useNavigate();

  const handleGetUsersWithNoWebsites = async () => {
    const config = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };
    try {
      const res = await handleUsersWithNoWebsites(config);

      if (res?.status === 200) {
        setUsersWithNoWebsite(res?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleGetUsersWebsites = async () => {
    const config = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };
    try {
      const res = await handleUserWebsites(config);

      if (res?.status === 200) {
        setUserWebsites(res?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    Promise.all([handleGetUsersWithNoWebsites(), handleGetUsersWebsites()]);
  }, []);

  const UserReport = [
    {
      name: "Total users",
      value: users.length || 0,
      icon: <UsersIcon size={18} className="text-slate-400" />,
      to: "/users",
    },
    {
      name: "Total Websites",
      value: userWebsites.totalCount || 0,
      icon: <AppWindowIcon size={18} className="text-slate-400" />,
      to: "/websites",
    },
    {
      name: "Registered users with 0 websites",
      value: usersWithNoWebsite.count || 0,
      icon: <ArrowUp01Icon size={18} className="text-slate-400" />,
      to: "/users-no-websites",
    },
    {
      name: "Total websites user's selected",
      value: userWebsites.selectedSitesCount || 0,
      icon: <MousePointerSquareIcon size={18} className="text-slate-400" />,
      to: "/users-selected-websites",
    },
    {
      name: "Total Subscriptions",
      value: subscriptions?.length || 0,
      icon: <DollarSignIcon size={18} className="text-slate-400" />,
      to: "/payments",
    },
  ];

  return (
    <div className="grid grid-cols-1 gap-10 2xl:grid-cols-3 xl:grid-cols-3 lg:grid-cols-1 md:grid-cols-1 ">
      {UserReport?.map((item, index) => (
        <div
          className={`bg-white ring-2 ring-gray-200 rounded-[20px] p-6 ${
            item.to
              ? "hover:ring-2 hover:ring-indigo-300 transition-all duration-300 cursor-pointer"
              : ""
          }`}
          key={index}
          onClick={() => navigate(item.to)}
        >
          <div className="flex justify-between items-center">
            <p className="font-medium antialiased tracking-normal text-foreground text-slate-500">
              {item.name}
            </p>

            {item.icon}
          </div>

          <div className="mt-2 ">
            <p className="text-2xl font-bold">{item.value}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default UserReports;
